import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useSnapshot } from "valtio";
import { UnreachableCaseError } from "../../lib/errors";
import { useTransactionStatus } from "../../polychain/hooks";
import { FlowActions, FlowState } from "../../stores/flowStore";

// TODO: Remove this once all flows are using BE receipt resolvers
export function useFlowFinalTransactionStatus() {
  const $ = _c(2);
  const {
    receiptTransactions
  } = useSnapshot(FlowState);
  const finalTransaction = receiptTransactions[0];
  let t0;
  if ($[0] !== finalTransaction) {
    t0 = {
      transaction: finalTransaction
    };
    $[0] = finalTransaction;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const status = useTransactionStatus(t0);
  useSetFlowFinalTransactionStatus(status);
  return status;
}
function transactionStatusToReceiptStatus(status) {
  switch (status) {
    case "success":
      return "SUCCESS";
    case "pending":
      return "PENDING";
    case "error":
      return "FAILED";
    default:
      throw new UnreachableCaseError(status);
  }
}
export function useSetFlowFinalTransactionStatus(status) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== status) {
    t0 = function syncFlowStatus() {
      FlowActions.setReceiptStatus(transactionStatusToReceiptStatus(status));
      if (status === "success") {
        FlowActions.onSuccess();
      }
    };
    t1 = [status];
    $[0] = status;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}